import { __decorate, __metadata, __param } from "tslib";
import { elementDefine, onConnectedBodyShadow, onInitialize, addEventListener, event, innerHtmlLight, state, onConnectedBefore, innerHtml, attribute } from "@dooboostore/simple-web-component";
import { LottoService } from "../../services/lotto/LottoService";
import { Router } from '@dooboostore/core-web';
import { inject } from "@dooboostore/simple-boot";
const tagName = 'center-lotto-page';
export default (w) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const existing = w.customElements.get(tagName);
    if (existing)
        return tagName;
    let LottoPage = class LottoPage extends w.HTMLElement {
        constructor() {
            super(...arguments);
            Object.defineProperty(this, "router", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "lottoService", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // ---------- 상태 ----------
            Object.defineProperty(this, "latestRoundaaaa", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 0
            });
            Object.defineProperty(this, "kk", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 0
            });
            Object.defineProperty(this, "latestRound", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 0
            });
            Object.defineProperty(this, "selectedRound", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 0
            });
            Object.defineProperty(this, "activeTab", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'round'
            });
            Object.defineProperty(this, "statsRounds", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 5
            });
            Object.defineProperty(this, "excludeLatestRound", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "overlapAllowance", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 10
            });
            Object.defineProperty(this, "setRequestCount", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 5
            });
            Object.defineProperty(this, "includeBonusBall", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: true
            });
            Object.defineProperty(this, "currentLotto", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: null
            });
            Object.defineProperty(this, "numberStats", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Map()
            });
            Object.defineProperty(this, "recommendedSets", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty(this, "combinedSet", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty(this, "latestRoundNumbers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty(this, "latestBonusNumber", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 0
            });
        }
        setPageMeta() {
            return {
                titleBody: "Lotto Analytics | @dooboostore",
                ogTitle: "Lotto Analytics | @dooboostore",
                desc: "로또 당첨 번호 분석 및 통계 데이터를 시각적으로 확인하세요.",
                ogDesc: "로또 당첨 번호 분석 및 통계 데이터를 시각적으로 확인하세요.",
                ogImage: "/assets/images/lotto-og.png",
                twitterImage: "/assets/images/lotto-og.png",
                twitterTitle: "Lotto Analytics | @dooboostore",
                twitterDesc: "로또 당첨 번호 분석 및 통계 데이터를 시각적으로 확인하세요.",
            };
        }
        async onInitialized(lottoService, router) {
            this.lottoService = lottoService;
            this.router = router;
            this.latestRound = await this.lottoService.getLatestRoundNumber();
            this.selectedRound = this.latestRound;
            await this.loadRoundData(this.selectedRound);
        }
        // ---------- 데이터 로딩 ----------
        async loadRoundData(round) {
            this.currentLotto = (await this.lottoService.getLottoRound(round)) || null;
            this.renderTabContent();
        }
        async loadStatsData(count) {
            const fetchCount = this.excludeLatestRound ? count + 1 : count;
            const list = await this.lottoService.getLottoList(this.latestRound, fetchCount);
            const stats = new Map();
            for (let i = 1; i <= 45; i++)
                stats.set(i, 0);
            if (list.length > 0) {
                const latest = list[0];
                this.latestRoundNumbers = [
                    latest.tm1WnNo, latest.tm2WnNo, latest.tm3WnNo,
                    latest.tm4WnNo, latest.tm5WnNo, latest.tm6WnNo,
                ];
                this.latestBonusNumber = latest.bnsWnNo;
            }
            const targetList = this.excludeLatestRound ? list.slice(1, count + 1) : list.slice(0, count);
            targetList.forEach(item => {
                [
                    item.tm1WnNo,
                    item.tm2WnNo,
                    item.tm3WnNo,
                    item.tm4WnNo,
                    item.tm5WnNo,
                    item.tm6WnNo,
                    ...(this.includeBonusBall ? [item.bnsWnNo] : []),
                ].forEach((num) => {
                    stats.set(num, (stats.get(num) || 0) + 1);
                });
            });
            this.numberStats = stats;
            this.renderTabContent();
        }
        // ---------- light DOM 컨텐츠 렌더 (@innerHtmlLight -> shadow <slot>) ----------
        renderTabContent() {
            const isStats = this.activeTab === 'stats';
            return `
        <style>
          ${this.contentStyles}
        </style>
        ${isStats ? this.buildStatsControls() : this.buildRoundControls()}
        <div class="lotto-paper">
          <div class="grid">${isStats ? this.buildStatsGrid() : this.buildRoundGrid()}</div>
        </div>
        ${isStats ? this.buildRecommendationArea() : ''}
      `;
        }
        // ---------- 렌더 상태 빌더 ---------- {{ @aa@ }}
        get contentStyles() {
            // {{ @aa@. }}
            return `
        .controls { margin-bottom: 20px; display: flex; gap: 10px; align-items: center; justify-content: center; flex-wrap: wrap; }
        select, button, input[type="number"] { padding: 8px 12px; border-radius: 6px; border: 1px solid #ddd; font-size: 14px; outline: none; }
        input[type="number"] { width: 110px; text-align: center; }
        button { background: #1976d2; color: white; border: none; cursor: pointer; font-weight: bold; }
        button:hover { background: #1565c0; }
        .lotto-paper {
          background: #fffbe6; border: 2px solid #d4c4a8; padding: 15px; border-radius: 4px; position: relative;
          background-image: radial-gradient(#d4c4a8 1px, transparent 1px); background-size: 20px 20px; margin-bottom: 20px;
        }
        .grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 8px; }
        .number-cell {
          aspect-ratio: 1; border: 1px solid #d4c4a8; display: flex; align-items: center;
          justify-content: center; font-size: 14px; background: white; position: relative; font-weight: bold; color: #444;
        }
        .number-cell.marked::after {
          content: ''; position: absolute; width: 80%; height: 80%; background: rgba(255, 0, 0, 0.7);
          clip-path: polygon(20% 0%, 0% 20%, 30% 50%, 0% 80%, 20% 100%, 50% 70%, 80% 100%, 100% 80%, 70% 50%, 100% 20%, 80% 0%, 50% 30%);
        }
        .number-cell.bonus::after {
          content: ''; position: absolute; width: 80%; height: 80%; background: rgba(0, 0, 255, 0.5); border-radius: 50%;
        }
        .number-cell.stats { flex-direction: column; font-size: 10px; gap: 2px; }
        .bar-container { width: 100%; height: 20px; background: #eee; position: relative; overflow: hidden; }
        .bar { position: absolute; bottom: 0; left: 0; width: 100%; background: #ff9800; transition: height 0.3s; }
        .recommendation-area { border-top: 2px dashed #ddd; padding-top: 20px; text-align: center; }
        .rec-title { font-weight: bold; margin-bottom: 15px; color: #333; }
        .set-row { margin-bottom: 15px; padding: 10px; background: #f9f9f9; border-radius: 8px; }
        .ball-container { display: flex; gap: 8px; justify-content: center; }
        .ball {
          width: 34px; height: 34px; border-radius: 50%; display: flex; align-items: center; justify-content: center;
          color: white; font-weight: bold; font-size: 13px; text-shadow: 0 1px 2px rgba(0,0,0,0.3);
          box-shadow: inset -2px -2px 4px rgba(0,0,0,0.2), 0 2px 4px rgba(0,0,0,0.1);
        }
        .ball-0 { background: #fbc02d; }
        .ball-1 { background: #1976d2; }
        .ball-2 { background: #d32f2f; }
        .ball-3 { background: #7b1fa2; }
        .ball-4 { background: #388e3c; }
        .round-info { text-align: center; margin-bottom: 15px; }
        .round-title { font-size: 20px; font-weight: bold; margin-bottom: 5px; }
        .round-date { font-size: 14px; color: #888; }
        .exclude-label { display: flex; align-items: center; gap: 6px; font-size: 13px; color: #555; cursor: pointer; user-select: none; }
        .exclude-label input[type="checkbox"] { width: 15px; height: 15px; cursor: pointer; accent-color: #1976d2; }
        .ball.ball-latest-win { outline: 3px solid #ff3d00; outline-offset: 2px; position: relative; }
        .ball.ball-latest-bonus { outline: 3px solid #aa00ff; outline-offset: 2px; position: relative; }
        .latest-dot { position: absolute; top: -4px; right: -4px; width: 8px; height: 8px; border-radius: 50%; border: 1px solid white; }
        .dot-win { background: #ff3d00; }
        .dot-bonus { background: #aa00ff; }
        .combine-section { margin-bottom: 16px; background: #f0f7ff; border: 1px solid #bbdefb; border-radius: 10px; padding: 12px; }
        .combine-header { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
        .combine-label { font-size: 13px; color: #1565c0; font-weight: bold; }
        .combine-result { margin-top: 12px; display: flex; justify-content: center; }

        @media (max-width: 480px) {
          .lotto-paper { padding: 8px; border-width: 1px; }
          .grid { gap: 4px; }
          .number-cell { font-size: 11px; }
          .number-cell.stats { font-size: 8px; gap: 1px; }
          .bar-container { height: 14px; }
          .count { font-size: 7px; }
          .ball { width: 30px; height: 30px; font-size: 11px; }
          .controls { gap: 5px; }
          select, button, input[type="number"] { padding: 6px 8px; font-size: 12px; }
          .exclude-label { font-size: 12px; }
        }
      `;
        }
        buildRoundControls() {
            const roundOptions = Array.from({ length: this.latestRound }, (_, i) => this.latestRound - i)
                .map(r => `<option value="${r}" ${r === this.selectedRound ? 'selected' : ''}>${r}회</option>`)
                .join('');
            // {{ @@aa@.toExponential()}}
            return `
        <div class="controls">
          <select id="round-select">
            ${roundOptions}
          </select>
        </div> 
<!--<div a::ww="@aa@ @kk@">test</div>-->
        <div class="round-info">
          <div class="round-title">${this.currentLotto?.ltEpsd || ""}회 당첨 결과</div>
          <div class="round-date">${this.currentLotto?.ltRflYmd || ""} 추첨</div>
        </div>
      `;
        }
        buildStatsControls() {
            return `
        <div class="controls">
          <span>최근</span>
          <input type="number" id="stats-select" value="${this.statsRounds}" min="1" max="100">
          <span>회 분석</span>
        </div>
        <div class="controls" style="justify-content: center; margin-top: -8px;">
          <label class="exclude-label">
            <input type="checkbox" id="exclude-latest-checkbox" ${this.excludeLatestRound ? 'checked' : ''}>
            최신 회차(${this.latestRound}회) 제외
          </label>
          <label class="exclude-label">
            <input type="checkbox" id="include-bonus-checkbox" ${this.includeBonusBall ? 'checked' : ''}>
            보너스볼 포함
          </label>
        </div>
      `;
        }
        buildRoundGrid() {
            const roundNumbers = this.currentLotto
                ? [this.currentLotto.tm1WnNo, this.currentLotto.tm2WnNo, this.currentLotto.tm3WnNo, this.currentLotto.tm4WnNo, this.currentLotto.tm5WnNo, this.currentLotto.tm6WnNo]
                : [];
            const bonusNumber = this.currentLotto?.bnsWnNo || 0;
            return Array.from({ length: 45 }, (_, i) => i + 1).map(num => {
                const isSelected = roundNumbers.includes(num);
                const isBonus = bonusNumber === num;
                return `<div class="number-cell ${isSelected ? 'marked' : ''} ${isBonus ? 'bonus' : ''}">${num}</div>`;
            }).join('');
        }
        buildStatsGrid() {
            return Array.from({ length: 45 }, (_, i) => i + 1).map(num => {
                const count = this.numberStats.get(num) || 0;
                const percentage = (count / this.statsRounds) * 100;
                return `
          <div class="number-cell stats">
            <span class="num">${num}</span>
            <div class="bar-container">
              <div class="bar" style="height: ${Math.min(percentage, 100)}%"></div>
            </div>
            <span class="count">${count}</span>
          </div>
        `;
            }).join('');
        }
        buildBall(n) {
            const isLatest = this.latestRoundNumbers.includes(n);
            const isBonus = this.latestBonusNumber === n;
            if (isLatest) {
                return `<div class="ball ball-${Math.floor((n - 1) / 10)} ball-latest-win" title="${this.latestRound}회 당첨번호">${n}<span class="latest-dot dot-win"></span></div>`;
            }
            else if (isBonus) {
                return `<div class="ball ball-${Math.floor((n - 1) / 10)} ball-latest-bonus" title="${this.latestRound}회 보너스번호">${n}<span class="latest-dot dot-bonus"></span></div>`;
            }
            else {
                return `<div class="ball ball-${Math.floor((n - 1) / 10)}">${n}</div>`;
            }
        }
        buildResults() {
            if (this.recommendedSets.length === 0)
                return '';
            const uniqueCount = Array.from(new Set(this.recommendedSets.flat())).length;
            const combineSection = `
        <div class="combine-section">
          <div class="combine-header">
            <span class="combine-label">추출된 ${uniqueCount}개 번호에서 조합</span>
            <button id="combine-btn">조합하기</button>
          </div>
          ${this.combinedSet.length === 6 ? `
            <div class="combine-result">
              <div class="ball-container">
                ${this.combinedSet.map(n => this.buildBall(n)).join('')}
              </div>
            </div>
          ` : ''}
        </div>
      `;
            const setsHtml = this.recommendedSets.map((set, idx) => `
        <div class="set-row">
          <div style="font-size: 11px; color: #888; margin-bottom: 5px;">Set ${idx + 1}</div>
          <div class="ball-container">
            ${set.map(n => this.buildBall(n)).join('')}
          </div>
        </div>
      `).join('');
            return `${combineSection}<div class="results-list">${setsHtml}</div>`;
        }
        buildRecommendationArea() {
            return `
        <div class="recommendation-area">
          <div class="rec-title">분석 기반 번호 추천</div>
          <div class="controls">
            <input type="number" id="allowance-select" value="${this.overlapAllowance}" min="0" max="100">
            <span>% 중복 허용</span>
            <input type="number" id="set-count-input" value="${this.setRequestCount}" min="1" max="100">
            <span>게임</span>
            <button id="recommend-btn">추출</button>
          </div>
          ${this.buildResults()}
        </div>
      `;
        }
        // ---------- 상태 변경 / 추천 로직 ----------
        generateRecommendation() {
            const limit = Math.floor(this.statsRounds * (this.overlapAllowance / 100));
            let basePool = [];
            for (let i = 1; i <= 45; i++) {
                if ((this.numberStats.get(i) || 0) <= limit) {
                    basePool.push(i);
                }
            }
            if (basePool.length < 6) {
                const sorted = Array.from({ length: 45 }, (_, i) => i + 1)
                    .sort((a, b) => (this.numberStats.get(a) || 0) - (this.numberStats.get(b) || 0));
                basePool = Array.from(new Set([...basePool, ...sorted.slice(0, 6)]));
            }
            const sets = [];
            for (let s = 0; s < this.setRequestCount; s++) {
                const shuffled = [...basePool].sort(() => Math.random() - 0.5);
                const picked = shuffled.slice(0, 6).sort((a, b) => a - b);
                sets.push(picked);
            }
            this.recommendedSets = sets;
            this.combinedSet = [];
            this.renderTabContent();
        }
        generateCombination() {
            const pool = Array.from(new Set(this.recommendedSets.flat())).sort((a, b) => a - b);
            if (pool.length < 6)
                return;
            const shuffled = [...pool].sort(() => Math.random() - 0.5);
            this.combinedSet = shuffled.slice(0, 6).sort((a, b) => a - b);
            this.renderTabContent();
        }
        // ---------- 이벤트 핸들러 (동적 영역은 @addEventListener delegate) ----------
        async onTabChange(e) {
            const form = e.target.form;
            const formData = new FormData(form);
            const tab = formData.get('tab');
            if (this.activeTab === tab)
                return;
            this.activeTab = tab;
            if (tab === 'stats') {
                await this.loadStatsData(this.statsRounds);
            }
            else {
                await this.loadRoundData(this.selectedRound);
            }
        }
        async onRoundChange(e) {
            const select = e.target;
            this.selectedRound = Number(select.value);
            await this.loadRoundData(this.selectedRound);
        }
        async onStatsChange(e) {
            const input = e.target;
            let val = Number(input.value);
            if (val < 1)
                val = 1;
            if (val > 100)
                val = 100;
            this.statsRounds = val;
            await this.loadStatsData(this.statsRounds);
        }
        onAllowanceChange(e) {
            const input = e.target;
            let val = Number(input.value);
            if (val < 0)
                val = 0;
            if (val > 100)
                val = 100;
            this.overlapAllowance = val;
        }
        onSetCountInput(e) {
            const input = e.target;
            let val = Number(input.value);
            if (val < 1)
                val = 1;
            if (val > 100)
                val = 100;
            this.setRequestCount = val;
        }
        onRecommendClick() {
            this.generateRecommendation();
        }
        onCombineClick() {
            this.generateCombination();
        }
        async onExcludeLatestChange(e) {
            const checkbox = e.target;
            this.excludeLatestRound = checkbox.checked;
            await this.loadStatsData(this.statsRounds);
        }
        async onIncludeBonusChange(e) {
            const checkbox = e.target;
            this.includeBonusBall = checkbox.checked;
            await this.loadStatsData(this.statsRounds);
        }
        // ---------- 템플릿 (정적 구조 + 동적 영역 마커) ----------
        render() {
            return `
        <style>
          *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
          :host { display: block; font-family: var(--font-family, sans-serif); background: #f0f2f5; min-height: 100vh; }
          .header {
            display: flex; align-items: center; gap: 12px;
            padding: 16px 24px;
            background: linear-gradient(135deg, #1565c0 0%, #1976d2 60%, #42a5f5 100%);
            color: white;
          }
          .header-back {
            background: rgba(255,255,255,0.2); border: none; color: white;
            width: 40px; height: 40px; border-radius: 8px; cursor: pointer;
            display: flex; align-items: center; justify-content: center; font-size: 20px;
          }
          .header-back:hover { background: rgba(255,255,255,0.3); }
          .header-title { font-size: 22px; font-weight: 700; flex: 1; }
          .header-hits { height: 20px; border-radius: 4px; opacity: 0.9; margin-left: auto; }

          .main-container { max-width: 500px; margin: 24px auto; background: white; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.08); overflow: hidden; }
          .tabs { display: flex; background: #eee; border-bottom: 1px solid #ddd; }
          .tabs input[type="radio"] { display: none; }
          .tabs label { flex: 1; padding: 15px; text-align: center; cursor: pointer; font-weight: bold; color: #666; transition: 0.2s; }
          .tabs input[type="radio"]:checked + label { background: white; color: #1976d2; border-bottom: 2px solid #1976d2; }
          .content { padding: 20px; }
          .copyright {
            text-align: center; padding: 24px 16px; color: #aaa; font-size: 13px;
            border-top: 1px solid #eee; margin-top: 24px;
          }

          @media (max-width: 600px) {
            .header { padding: 14px 16px; }
            .header-title { font-size: 18px; }
            .main-container { margin: 12px; border-radius: 8px; box-shadow: none; }
            .content { padding: 12px; }
          }
        </style>

        <div class="header">
          <button class="header-back" aria-label="Go home" title="홈으로">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5L12 3l9 7.5"/><path d="M5 9.5V21h14V9.5"/></svg>
          </button>
          <div>
            <div class="header-title">🎰 Lotto Analytics</div>
          </div>
          <img class="header-hits" alt="Hits" src="https://hits.sh/hits.sh/dooboostore.github.io-apps-center-lotto.svg?style=plastic&amp;"/>
        </div>

        <main>
          <div class="main-container">
            <form class="tabs">
              <input type="radio" id="tab-round" name="tab" value="round" ${this.activeTab === 'round' ? 'checked' : ''}>
              <label for="tab-round">회차별 번호</label>
              <input type="radio" id="tab-stats" name="tab" value="stats" ${this.activeTab === 'stats' ? 'checked' : ''}>
              <label for="tab-stats">번호별 통계</label>
            </form>

            <div class="content">
              <slot></slot>
            </div>
          </div>
        </main>

        <footer class="copyright">
          © ${new Date().getFullYear()} dooboostore
        </footer>
      `;
        }
        onBackClick() {
            this.router?.go('/');
        }
    };
    __decorate([
        onConnectedBefore,
        innerHtml((c, helper) => helper.$w.document.querySelector("title"), { valueKey: "titleBody" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[property="og:title"]'), "content", { valueKey: "ogTitle" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[name="description"]'), "content", { valueKey: "desc" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[property="og:description"]'), "content", { valueKey: "ogDesc" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[property="og:image"]'), "content", { valueKey: "ogImage" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[name="twitter:image"]'), "content", { valueKey: "twitterImage" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[name="twitter:title"]'), "content", { valueKey: "twitterTitle" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[name="twitter:description"]'), "content", { valueKey: "twitterDesc" }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], LottoPage.prototype, "setPageMeta", null);
    __decorate([
        state('aa'),
        __metadata("design:type", Number)
    ], LottoPage.prototype, "latestRoundaaaa", void 0);
    __decorate([
        state,
        __metadata("design:type", Number)
    ], LottoPage.prototype, "kk", void 0);
    __decorate([
        onInitialize,
        __param(0, inject(LottoService.SYMBOL)),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, typeof (_a = typeof Router !== "undefined" && Router) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], LottoPage.prototype, "onInitialized", null);
    __decorate([
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", String)
    ], LottoPage.prototype, "renderTabContent", null);
    __decorate([
        event('.tabs', 'change', { preventDefault: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof Event !== "undefined" && Event) === "function" ? _c : Object]),
        __metadata("design:returntype", Promise)
    ], LottoPage.prototype, "onTabChange", null);
    __decorate([
        addEventListener('#round-select', 'change', { delegate: true, root: 'light' }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof Event !== "undefined" && Event) === "function" ? _d : Object]),
        __metadata("design:returntype", Promise)
    ], LottoPage.prototype, "onRoundChange", null);
    __decorate([
        addEventListener('#stats-select', 'input', { delegate: true, root: 'light' }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof Event !== "undefined" && Event) === "function" ? _e : Object]),
        __metadata("design:returntype", Promise)
    ], LottoPage.prototype, "onStatsChange", null);
    __decorate([
        addEventListener('#allowance-select', 'input', { delegate: true, root: 'light' }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof Event !== "undefined" && Event) === "function" ? _f : Object]),
        __metadata("design:returntype", void 0)
    ], LottoPage.prototype, "onAllowanceChange", null);
    __decorate([
        addEventListener('#set-count-input', 'input', { delegate: true, root: 'light' }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof Event !== "undefined" && Event) === "function" ? _g : Object]),
        __metadata("design:returntype", void 0)
    ], LottoPage.prototype, "onSetCountInput", null);
    __decorate([
        addEventListener('#recommend-btn', 'click', { delegate: true, root: 'light' }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], LottoPage.prototype, "onRecommendClick", null);
    __decorate([
        addEventListener('#combine-btn', 'click', { delegate: true, root: 'light' }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], LottoPage.prototype, "onCombineClick", null);
    __decorate([
        addEventListener('#exclude-latest-checkbox', 'change', { delegate: true, root: 'light' }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof Event !== "undefined" && Event) === "function" ? _h : Object]),
        __metadata("design:returntype", Promise)
    ], LottoPage.prototype, "onExcludeLatestChange", null);
    __decorate([
        addEventListener('#include-bonus-checkbox', 'change', { delegate: true, root: 'light' }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_j = typeof Event !== "undefined" && Event) === "function" ? _j : Object]),
        __metadata("design:returntype", Promise)
    ], LottoPage.prototype, "onIncludeBonusChange", null);
    __decorate([
        onConnectedBodyShadow,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], LottoPage.prototype, "render", null);
    __decorate([
        addEventListener('.header-back', 'click'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], LottoPage.prototype, "onBackClick", null);
    LottoPage = __decorate([
        elementDefine(tagName, { window: w })
    ], LottoPage);
    return tagName;
};
